
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetobhimashankarjyotilingabushire() {



    const cardData =
    {
        keyword: 'Pune to Bhimashankar Jyotirlinga Bus Hire in Pune',
        heading: 'Amruta Travels: Pune to Bhimashankar Jyotirlinga Bus Hire in Pune',
        headingDescription: 'Amruta Travels offers Pune to Bhimashankar Jyotirlinga Bus Hire, providing a reliable and comfortable transportation solution for pilgrims and travelers. Whether you are planning a spiritual journey, a family trip, or a group tour, our well-maintained buses ensure a smooth and enjoyable ride to Bhimashankar. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your travel to Bhimashankar simple and stress-free. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. Book your Pune to Bhimashankar Bus with Amruta Travels and embark on a journey of comfort and devotion!,',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],
  "services": [
    {
      "name": "Pune to Bhimashankar Jyotirlinga Tempo Traveller",
      "description": "Travel in comfort to the Bhimashankar Jyotirlinga with Amruta Travels’ Tempo Traveller service from Pune. Our fully air-conditioned vehicles provide ample space and comfort, ideal for small groups or families on a spiritual journey to one of Maharashtra’s most revered temples."
    },
    {
      "name": "Pune to Bhimashankar 17 Seater Bus on Rent",
      "description": "Hire a 17-seater bus for your journey from Pune to Bhimashankar. Amruta Travels offers comfortable buses for religious tours, ensuring a safe and relaxed ride to Bhimashankar, complete with experienced drivers and modern amenities."
    },
    {
      "name": "Pune to Bhimashankar Mini Bus on Rent",
      "description": "Opt for a mini bus rental from Pune to Bhimashankar for a compact and comfortable group journey. Perfect for medium-sized groups, our mini buses are equipped with air conditioning, spacious seating, and a smooth ride for a divine experience."
    },
    {
      "name": "Pune to Jyotirlinga Bhimashankar Bus on Rent",
      "description": "Book a bus from Pune to Bhimashankar Jyotirlinga with Amruta Travels. Our buses cater to larger groups, ensuring a comfortable and serene journey, allowing you to focus on your spiritual experience while we take care of the travel details."
    },
    {
      "name": "14 Seater AC Tempo Traveller On Rent in Pune",
      "description": "For smaller groups, Amruta Travels offers 14-seater AC Tempo Travellers for hire in Pune. Whether it's a family outing or a corporate group, our Tempo Traveller service provides comfortable seating, air conditioning, and a hassle-free experience for your trip to Bhimashankar."
    },
    {
      "name": "Pune to Bhimashankar Round Trip Bus on Rent",
      "description": "Make your Bhimashankar pilgrimage more convenient with our round trip bus hire service. Amruta Travels offers round trip buses for Pune to Bhimashankar, ensuring that your return journey is just as comfortable as the way there."
    },
    {
      "name": "Pune to 5 Jyotirlinga Darshan Bus on Rent",
      "description": "Visit all five Jyotirlingas in Maharashtra with Amruta Travels. We offer comfortable buses for your Jyotirlinga Darshan tour, including Bhimashankar, and ensure that your entire journey is smooth and pleasant with experienced drivers and modern amenities."
    },
    {
      "name": "Pune to Bhimashankar AC Bus on Rent",
      "description": "Travel in style with our air-conditioned buses for your Pune to Bhimashankar journey. Perfect for larger groups, our AC buses ensure a comfortable and refreshing trip to the Bhimashankar temple."
    },
    {
      "name": "Best Bus Hire Pune to Bhimashankar",
      "description": "For the best travel experience from Pune to Bhimashankar, trust Amruta Travels for your bus hire needs. Our well-maintained fleet of buses ensures comfort, safety, and punctuality, making it the ideal choice for a peaceful and spiritual trip."
    },
    {
      "name": "Pune to Bhimashankar Bus Tour Package",
      "description": "Amruta Travels offers a complete Bhimashankar Bus Tour Package from Pune. The package includes comfortable transportation, driver services, and a smooth journey to and from the Bhimashankar Jyotirlinga, ensuring a hassle-free pilgrimage."
    },
    {
      "name": "Pune to Jyotirlinga Darshan One Day Tour Package",
      "description": "Take a one-day tour of the Jyotirlingas from Pune with Amruta Travels. This package includes visits to Bhimashankar and other nearby Jyotirlingas, with convenient bus transport, experienced guides, and AC comfort throughout the journey."
    },
    {
      "name": "3 Jyotirlinga in Maharashtra Tour Package From Pune",
      "description": "Experience a tour of three major Jyotirlingas in Maharashtra with Amruta Travels. Our package includes bus rentals for comfortable and reliable transport, guiding you through Bhimashankar and other significant Jyotirlinga locations for a spiritual journey."
    },
    {
      "name": "Bhimashankar Jyotirlinga Bus From Pune",
      "description": "Book a bus from Pune to Bhimashankar Jyotirlinga with Amruta Travels for a convenient and affordable pilgrimage trip. Our buses are equipped with AC comfort, spacious seating, and are driven by experienced drivers who ensure a safe and peaceful journey."
    }
  ],
  "tableData": [
    ["Pune to Bhimashankar Jyotirlinga Tempo Traveller", "Pune to Bhimashankar 17 Seater Bus on Rent"],
    ["Pune to Bhimashankar Mini Bus on Rent", "Pune to Jyotirlinga Bhimashankar Bus on Rent"],
    ["14 Seater AC Tempo Traveller On Rent in Pune", "Pune to Bhimashankar Round Trip Bus on Rent"],
    ["Pune to 5 Jyotirlinga Darshan Bus on Rent", "Pune to Bhimashankar AC Bus on Rent"],
    ["Best Bus Hire Pune to Bhimashankar", "Pune to Bhimashankar Bus Tour Package"],
    ["Pune to Jyotirlinga Darshan One Day Tour Package", "3 Jyotirlinga in Maharashtra Tour Package From Pune"],
    ["Bhimashankar Jyotirlinga Bus From Pune", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Comfortable Journey to Bhimashankar",
    "WhyChoosedescription": "Amruta Travels offers specialized Pune to Bhimashankar Jyotirlinga Bus Hire in Pune, ensuring a comfortable and safe journey to one of the most revered Jyotirlingas in India. Our buses are equipped with spacious seating and air conditioning for a pleasant trip."
  },
  {
    "WhyChooseheading": "Ideal for Religious Groups and Pilgrims",
    "WhyChoosedescription": "Our buses are perfect for religious groups, families, and pilgrims visiting Bhimashankar Jyotirlinga. We provide comfortable, hassle-free transport so you can focus on your spiritual journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are familiar with the route to Bhimashankar and ensure a smooth, timely, and safe journey. Their courteous demeanor and professionalism make your trip stress-free."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive rates for Pune to Bhimashankar Jyotirlinga Bus Hire in Pune. With no hidden charges, you can plan your pilgrimage without any unexpected costs."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Buses",
    "WhyChoosedescription": "We ensure that all our buses are meticulously cleaned and well-maintained, providing you with a comfortable and hygienic environment throughout the journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Options",
    "WhyChoosedescription": "We offer flexible scheduling and convenient pick-up/drop-off points for your journey to Bhimashankar. Whether you want to depart early in the morning or later, we can accommodate your preferred timings."
  },
  {
    "WhyChooseheading": "Customized Itinerary for Your Convenience",
    "WhyChoosedescription": "We offer a flexible itinerary to suit your group’s needs. Whether it’s a direct route or additional stops, we can customize the trip to ensure maximum convenience for your spiritual journey."
  },
  {
    "WhyChooseheading": "Easy Booking and Full Support",
    "WhyChoosedescription": "Booking a bus for your pilgrimage to Bhimashankar with Amruta Travels is quick and easy. Our customer support team is available to assist with booking, planning, and any travel-related queries."
  }
]

































    }

const faqData = [
  {
    question: 'How can I hire a bus for a trip from Pune to Bhimashankar Jyotirlinga?',
    answer: 'Hiring a bus from Pune to Bhimashankar Jyotirlinga with Amruta Travels is simple. You can book online, call our support team, or visit our office. We’ll help you choose the best bus based on your group size and travel preferences.',
  },
  {
    question: 'What types of buses are available for the Pune to Bhimashankar Jyotirlinga trip?',
    answer: 'We offer a variety of buses, including 32, 35, 45, and 50 seater options. Whether you prefer a standard or luxury bus, we have vehicles to suit every need, ensuring comfort and safety on your trip.',
  },
  {
    question: 'How long does it take to travel from Pune to Bhimashankar Jyotirlinga?',
    answer: 'The travel time from Pune to Bhimashankar Jyotirlinga is approximately 3 to 4 hours, depending on traffic conditions. Our drivers are experienced and ensure a smooth and timely journey.',
  },
  {
    question: 'Are the buses comfortable for the long journey to Bhimashankar Jyotirlinga?',
    answer: 'Yes, all our buses are well-maintained and equipped with comfortable seating, air conditioning, and spacious interiors, making the long journey enjoyable for all passengers.',
  },
  {
    question: 'Can I book a bus for a one-day trip to Bhimashankar Jyotirlinga?',
    answer: 'Absolutely! You can book a bus for a one-day trip to Bhimashankar Jyotirlinga. We’ll plan the trip based on your preferred schedule and ensure timely arrivals and departures.',
  },
  {
    question: 'Do you provide buses for both group and individual trips to Bhimashankar Jyotirlinga?',
    answer: 'Yes, whether you are traveling with a small group or a large one, we offer flexible bus options to accommodate your travel needs to Bhimashankar Jyotirlinga.',
  },
  {
    question: 'How much does it cost to hire a bus for Pune to Bhimashankar Jyotirlinga?',
    answer: 'The cost depends on the bus size, duration of the trip, and any additional services you require. Please contact us for a customized quote based on your specific travel details.',
  },
  {
    question: 'Can I customize the pickup and drop-off locations for the trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. Just provide us with your preferred pickup points, and we’ll plan the route to accommodate your travel needs.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Bhimashankar Jyotirlinga bus hire?',
    answer: 'Amruta Travels offers reliable, comfortable, and punctual bus services to Bhimashankar Jyotirlinga. We prioritize passenger safety and comfort, and our drivers are experienced and knowledgeable about the route.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ramesh Deshmukh',
    role: 'Temple Visit Coordinator, Pune',
    text: 'We hired a 45-seater bus from Amruta Travels for a group trip to Bhimashankar Jyotirlinga. The service was fantastic! The bus was clean, comfortable, and the driver was knowledgeable about the route. It made the pilgrimage very smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Jadhav',
    role: 'Devotee, Pune',
    text: 'Our family trip to Bhimashankar Jyotirlinga was made more enjoyable with Amruta Travels. The bus was spacious and well-maintained, and the driver ensured a safe and comfortable journey. I highly recommend their service for temple trips.',
    rating: 5,
  },
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Jyotirlinga Bus Hire",
  "image": "https://bushireinpune.com/assets/images/pune-to-bhimashankar-bus-hire.jpg",
  "description": "Book a comfortable and affordable bus for Bhimashankar Jyotirlinga darshan. Choose from 14-seater to 17-seater buses and tempo travellers for a smooth and scenic journey from Pune to Bhimashankar.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4850"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999", // Adjust based on your pricing
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-bhimashankar-jyotirlinga-bus-hire"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune to Bhimashankar Jyotirlinga Bus Hire | Affordable & Comfortable Bus Services | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book your Pune to Bhimashankar Jyotirlinga darshan bus with Amruta Travels. Choose from AC buses and tempo travellers for a comfortable and affordable round trip journey." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/23.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetobhimashankarjyotilingabushire;